import { ObjectiveWorkflowState } from '@/api/models/aggregate'
import { useAppSelector } from '@/store/hooks'

export const useIsObjectiveWorkflowFinished = () => {
  const aggregate = useAppSelector((state) => state.aggregate.current)

  const { lastObjectiveWorkflow, lastObjectiveRecord } = aggregate || {}
  const { state: workflowState } = lastObjectiveWorkflow || {}

  return workflowState === ObjectiveWorkflowState.finished && Boolean(lastObjectiveRecord?.finished)
}
